<script>
import api from '@utils/api'
import mixins from '../apimixins'
import TablePaginator from '@components/paginator'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'

export default {
  name: 'CurrentOilVolume',
  components: {
    AdjustColumnsDialog,
    TablePaginator,
  },
  mixins: [mixins],
  data() {
    return {
      modelName: 'CurrentOilVolume',
      isLoading: false,
      showDialog: false,
      headers: [
        { text: 'workshop', value: 'organisation', sortable: true },
        { text: 'plugGuid', value: 'plug', sortable: true },
        { text: 'oil_type', value: 'oil', sortable: true, show: true },
        {
          text: 'drum_volume',
          value: 'drumVolume',
          sortable: true,
          show: true,
        },
        { text: 'current_volume_in', value: 'currentVolume', sortable: true },
        {
          text: 'current_temperature',
          value: 'currentTemperature',
          sortable: true,
          show: true,
        },
      ],
      otherParams: {
        filter_shipment_value: 'true',
        filter_shipment_comparison: 'EQ',
      },
    }
  },
  computed: {
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  mounted() {
    this.getPaginator()
    let filters = this.getFilters()
    if (this.filtersEmpty(filters) || this.$route.params.fromNotification) {
      this.getDataSet()
    }
  },
  methods: {
    getDataSet() {
      this.isLoading = true
      this.prepareFilterParams()
      api.getReportData('current_oil_volume', this.params).then(response => {
        this.setResponseParams(response)
        this.content = response.content.map(content => {
          const {
            organisation,
            oil,
            drumVolume,
            plug,
            currentVolume,
            currentTemperature,
          } = content
          return {
            organisation,
            oil,
            plug,
            drumVolume,
            currentVolume,
            currentTemperature,
          }
        })
        this.isLoading = false
      })
    },
  },
}
</script>

<template>
  <div>
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
            @click="changeSort(header)"
          >
            <span> {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <router-link
              v-if="userAllowedToNavigate && props.item.organisation"
              :to="{ name: 'organization', params: { orgId: props.item.organisation }} "> {{ getValue('organization', props.item.organisation) }}
            </router-link>
            <span v-if="!userAllowedToNavigate && props.item.organisation">{{ getValue('organization', props.item.organisation) }}</span>
            <span v-if="!props.item.organisation">{{ '-' }}</span>
          </td>
          <td> <router-link
            v-if="userAllowedToNavigate"
            :to="{ name: 'searchPlug', params: { serial: props.item.plug , goodsGroup: props.item.goodsGroup }} "> {{ props.item.plug }}
          </router-link>
            <span v-else>{{ props.item.plug }}</span>
          </td>
          <td v-if="!hideValues('oil')">{{ getValue('goods', props.item.oil) }}</td>
          <td v-if="!hideValues('drumVolume')">{{ `${(props.item.drumVolume / unitsMeasurement.volumeMultiplier).toFixed(1)}` }}</td>
          <td>{{ `${(props.item.currentVolume / unitsMeasurement.volumeMultiplier).toFixed(1)}` }}</td>
          <td v-if="!hideValues('currentTemperature')">{{ convertTemperature(props.item.currentTemperature) }}</td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)" />
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="modelName"
      @columns-updated="updateColumns"
    />
  </div>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
</style>
